import {E, GetEntries} from "js-vextensions";
import {observer_mgl} from "mobx-graphlink";
import React from "react";
import {Row, Select} from "react-vcomponents";
import {PageContainer, RunInAction_Set} from "web-vcore";
import {store} from "../../Store/index.js";
import {MonitorTab} from "../../Store/main/tools/monitor.js";
import {useExpandedNavBar} from "../../UI/@Shared/NavBar.js";
import {BeltPanel, BeltPanel_TopBarUI} from "./Monitor/BeltPanel.js";
import {CameraPanel_Monitor} from "./Monitor/CameraPanel.js";
import {LD1ConfigPanel} from "./Monitor/LD1ConfigPanel.js";
import {LD1Panel} from "./Monitor/LD1Panel.js";
import {LD1SettingsPanel} from "./Monitor/LD1SettingsPanel.js";
import {MusePanel} from "./Monitor/MusePanel.js";

// ui
// ==========

export const MonitorUI = observer_mgl(()=>{
	const uiState = store.main.tools.monitor;
	const largeVersion = useExpandedNavBar();

	return (
		<PageContainer preset="text" style={E(
			{padding: 0},
			uiState.tab == MonitorTab.Muse && {height: "100%"},
			uiState.tab == MonitorTab.Belt && {height: "100%"},
			uiState.tab == MonitorTab.LD1 && {height: "100%"},
			uiState.tab == MonitorTab.LD1Config && {height: "100%"},
			!largeVersion && {margin: "0 auto 0 auto"},
		)}>
			<Row>
				<Select displayType="button bar" options={GetEntries(MonitorTab)} value={uiState.tab} onChange={val=>{
					RunInAction_Set(()=>uiState.tab = val);
				}}/>
				<Row ml="auto">
					{uiState.tab == MonitorTab.Belt && <BeltPanel_TopBarUI/>}
				</Row>
			</Row>
			{uiState.tab == MonitorTab.Camera && <CameraPanel_Monitor/>}
			{uiState.tab == MonitorTab.Muse && <MusePanel/>}
			{uiState.tab == MonitorTab.Belt && <BeltPanel/>}
			{uiState.tab == MonitorTab.LD1 && <LD1Panel/>}
			{uiState.tab == MonitorTab.LD1Config && <LD1ConfigPanel/>}
			{uiState.tab == MonitorTab.LD1Settings && <LD1SettingsPanel/>}
		</PageContainer>
	);
});